import { Component } from 'react';
import { captureException } from '../lib/reporting.js';
import { Button } from '../components/ui/Button.jsx';
import { Wordmark } from '../components/layout/Wordmark.jsx';

/**
 * The last line of defence. A render error anywhere below this shows a page a
 * customer can act on rather than a blank white screen, and reports itself.
 *
 * Deliberately a class component — React has no hook equivalent of
 * componentDidCatch.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    captureException(error, { componentStack: info?.componentStack });
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="grid min-h-screen place-items-center bg-paper px-6">
        <div className="w-full max-w-md text-center">
          <Wordmark className="mx-auto h-5" />

          <p className="mt-10 font-mono text-2xs tracking-[0.16em] text-muted uppercase">Error</p>
          <h1 className="mt-3 font-display text-2xl tracking-[-0.02em] text-ink">
            This page stopped working
          </h1>
          <p className="mt-3 text-xs leading-relaxed text-muted">
            Something went wrong on our side and we have been told about it. Reloading usually
            fixes it. If it does not, the rest of the store is still fine.
          </p>

          <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
            <Button onClick={() => window.location.reload()}>Reload the page</Button>
            <Button variant="outline" href="/">
              Back to the shop
            </Button>
          </div>
        </div>
      </main>
    );
  }
}

export default ErrorBoundary;
